module.exports = "header.navbar {\n  background-color: #383838; }\n"